/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolMedicationIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-medication"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M10.32 15.22L10.32 16.45Q10.32 17.15 10.81 17.64Q11.3 18.13 12 18.13Q12.7 18.13 13.19 17.64Q13.68 17.15 13.68 16.45L13.68 15.22L14.9 15.22Q15.6 15.22 16.09 14.74Q16.57 14.25 16.57 13.55Q16.57 12.85 16.09 12.36Q15.6 11.88 14.9 11.88L13.68 11.88L13.68 10.65Q13.68 9.95 13.19 9.46Q12.7 8.97 12 8.97Q11.3 8.97 10.81 9.46Q10.32 9.95 10.32 10.65L10.32 11.88L9.1 11.88Q8.4 11.88 7.91 12.36Q7.42 12.85 7.42 13.55Q7.42 14.25 7.91 14.74Q8.4 15.22 9.1 15.22ZM6.9 21.8Q5.78 21.8 5.01 21.04Q4.25 20.27 4.25 19.15L4.25 7.95Q4.25 6.83 5.01 6.06Q5.78 5.3 6.9 5.3L17.1 5.3Q18.23 5.3 18.99 6.06Q19.75 6.83 19.75 7.95L19.75 19.15Q19.75 20.27 18.99 21.04Q18.23 21.8 17.1 21.8ZM6.92 4.75Q6.38 4.75 5.99 4.36Q5.6 3.98 5.6 3.42Q5.6 2.88 5.99 2.49Q6.38 2.1 6.92 2.1L17.13 2.1Q17.68 2.1 18.06 2.49Q18.45 2.88 18.45 3.42Q18.45 3.98 18.06 4.36Q17.68 4.75 17.13 4.75Z" fill={color} />
    </svg>
  );
}
